<template>
  <div v-if="track.expanded" id="player" class="column col-fixed">
    <progress-bar v-bind:soundcloud="soundcloud" v-bind:track="track"></progress-bar>
    <player-controls v-bind:soundcloud="soundcloud"></player-controls>
  </div>
</template>

<script>
import ProgressBar from '@/components/ListenPage/ProgressBar'
import PlayerControls from '@/components/ListenPage/PlayerControls'

export default {
  name: 'soundcloud-player',
  props: ['track', 'soundcloud'],
  components: { ProgressBar, PlayerControls }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ListenPage/SoundcloudPlayer.vue?57efdb0c